// extracted by mini-css-extract-plugin
module.exports = {"langSwitcher":"LanguagesSwitcher_langSwitcher__ymfTC","langSwitcherOption":"LanguagesSwitcher_langSwitcherOption__2V997","selected":"LanguagesSwitcher_selected__3Mmo7"};